import { render, staticRenderFns } from "./CityDistrictSelector.vue?vue&type=template&id=6979ac0a&scoped=true"
import script from "./CityDistrictSelector.vue?vue&type=script&lang=js"
export * from "./CityDistrictSelector.vue?vue&type=script&lang=js"
import style0 from "./CityDistrictSelector.vue?vue&type=style&index=0&id=6979ac0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6979ac0a",
  null
  
)

export default component.exports